import React, { useEffect, useState } from "react";
import { Form, Collapse, Table } from "react-bootstrap";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { editorProjectServices } from "../../../../APIServices/Editor/editorProjectServices";

const PublishedPackages = ({
  isFullScreenMode,
  openRightTab,
  isFullScreen,
  setIsFullScreen,
}) => {
  const [openPackages, setOpenPackages] = useState({});
  const [packageList, setPackageList] = useState([]);
  const [statements, setStatements] = useState([]);
  const [loader, setLoader] = useState(false);
  const togglePackage = (index) => {
    setOpenPackages((prev) => ({ ...prev, [index]: !prev[index] }));
  };
  const getOnlyPackageList = async (e) => {
    setLoader(true);
    let data = await editorProjectServices.getOnlyPackageList();
    setPackageList(data?.data || []);
    setLoader(false);
  };

  const getSinglePackageStatementData = async (packageId, version) => {
    let data = await editorProjectServices.getSinglePackageStatementData(
      packageId,
      version
    );
    setStatements(data?.data?.statements?.statements || []);
  };

  useEffect(() => {
    getOnlyPackageList();
  }, [openRightTab]);

  return (
    <div className="overflow-hidden w-100">
      <div
        className="justify-content-between toolbar border-bottom hstack w-100 p-1"
        style={{ height: 35 }}
      >
        <div className="hstack gap-1">
          <i className="fa-solid fa-cube"></i>
          <h6 className="m-0">Packages</h6>
        </div>
        <div className="hstack gap-1">
          <i
            title={`${isFullScreen ? "Minimize" : "Maximize"} Console`}
            className={`fa-solid ${
              isFullScreen ? "fa-minimize" : "fa-maximize"
            } CP`}
            onClick={() => setIsFullScreen(!isFullScreen)}
          />
        </div>
      </div>
      <div
        className="p-2"
        style={{
          height: isFullScreenMode
            ? "calc(100vh - 70px)"
            : "calc(100vh - 216px)",
          overflowY: "auto",
        }}
      >
        {loader ? (
          <PageLoader />
        ) : packageList?.length === 0 ? (
          <NoDataFoundTable MSG={"Packages not found!"} />
        ) : (
          packageList?.map((item, index) => (
            <div key={index}>
              <div
                className={`hstack justify-content-between bg-success-subtle mb-1 py-2 px-3 CP ${
                  openPackages[index] && "selectedMenu"
                }`}
                title={`View Example ${index + 1} Details`}
                onClick={() => {
                  togglePackage(index);
                  getSinglePackageStatementData(item?.packageId, item?.version);
                }}
              >
                <span className="fw-bold">
                  {index + 1}. {item.name}
                </span>
                <div className="hstack gap-2">
                  {!openPackages[index] ? (
                    <IoIosArrowForward />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </div>
              </div>
              <Collapse in={openPackages[index]}>
                <div className="py-2 px-3">
                  {statements?.map((stateMentData, index) => (
                    <div key={index} className="overflow-auto">
                      <Form.Label className="mb-1 fw-bold">
                        {index + 1}. {stateMentData?.statement}
                      </Form.Label>
                      <Form.Group className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Description :
                        </Form.Label>
                        <div className="fontSize12">
                          {stateMentData?.description}
                        </div>
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label className="mb-1 fw-bold">
                          Syntex :
                        </Form.Label>
                        <div className="fontSize12">
                          {stateMentData?.syntax};
                        </div>
                      </Form.Group>
                      {stateMentData?.arguments?.length > 0 && (
                        <>
                          <Form.Label className="mb-1 fw-bold">
                            Arguments :
                          </Form.Label>
                          <Table
                            bordered
                            className="border-start border-end custom-table tableLibrary m-0"
                            hover
                            size="sm"
                          >
                            <tbody>
                              {stateMentData?.arguments?.map((data, key) => (
                                <tr key={key}>
                                  <td className="fw-bold">{data.attribute}</td>
                                  <td style={{ whiteSpace: "break-spaces" }}>
                                    {data.value}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </>
                      )}
                      {(item?.statements?.statements || [])?.length !=
                        index + 1 && <hr />}
                    </div>
                  ))}
                </div>
              </Collapse>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PublishedPackages;
